import { render, staticRenderFns } from "./Recording.vue?vue&type=template&id=523740b1"
import script from "./Recording.vue?vue&type=script&lang=js"
export * from "./Recording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports